/*
Example use
htmlTest: {
ComponentName: 'HTML',
label: 'HTML Test',
classes: [],
options: { rawMarkup: "<p style='font-size:200%;'>I'm big text.</p>" },
},

How to add new formComponents:
1) see components/formelements for example
2) add the component in formTypes.js
*/
const erc20FieldDefinitions = {
  configureGroupHeader: {
    ComponentName: 'HTML',
    classes: ['group-break'],
    options: {
      rawMarkup: '<h2>Configure</h2>',
    },
  },
  name: {
    ComponentName: 'TextInput',
    label: 'Token Name',
    placeholder: '',
    description: '',
    validationSchema: 'STRING',
    required: true,
    classes: ['s12', 'l6'],
  },
  description: {
    ComponentName: 'TextAreaInput',
    label: 'Description',
    placeholder: '',
    description: 'Basic details about what the token is for. This field is private.',
    validationSchema: 'STRING',
    required: true,
    classes: ['s12', 'l6', 'right'],
  },
  ticker: {
    ComponentName: 'TextInput',
    label: 'Ticker',
    placeholder: '',
    description:
      'An abbreviation used to identify the token. Does not have to be unique. Examples: CAT, BCAT, BKCAT.',
    validationSchema: 'TICKER_SYMBOL',
    required: true,
    classes: ['s12', 'l6'],
  },
  decimals: {
    ComponentName: 'SliderInput',
    label: 'Decimals',
    placeholder: '',
    description: 'Number of decimal places the token can divide into.',
    validationSchema: 'INTEGER_FOR_TOKEN_DECIMAL',
    required: true,
    defaultValue: 1,
    classes: ['s12', 'l12'],
  },
  initialSupply: {
    ComponentName: 'TextInput',
    label: 'Initial Supply',
    placeholder: '',
    description: 'Number of tokens created upon contract deployment.',
    validationSchema: 'BIG_POSITIVE_INTEGER',
    required: true,
    classes: ['s12', 'l6'],
  },
  fixedSupply: {
    ComponentName: 'ToggleInput',
    label: 'Fixed Supply',
    placeholder: '',
    description: 'When enabled, the total supply for this token can never be changed.',
    validationSchema: 'BOOLEAN',
    classes: ['s12', 'l6', 'mutli-line-toggle'],
    defaultValue: false,
    required: false,
  },
  presetGroupHeader: {
    ComponentName: 'HTML',
    classes: ['group-break'],
    options: {
      rawMarkup: '<h2>Preset Functions</h2>',
    },
  },
  timeLocked: {
    ComponentName: 'ToggleInput',
    label: 'Time Locked',
    placeholder: '',
    description: 'When enabled, tokens cannot be transferred until the specified date.',
    validationSchema: 'BOOLEAN',
    classes: ['s12', 'l12'],
    defaultValue: false,
    required: false,
  },
  unlockDate: {
    ComponentName: 'DatePickerInput',
    label: 'Unlock Date',
    placeholder: '',
    description: 'The date when the token becomes available for use.',
    validationSchema: 'INTEGER',
    classes: ['s12', 'l12'],
    defaultValue: 0,
    dependency: 'timeLocked',
    required: false,
    requiredWithDependency: true,
  },
  transactionFee: {
    ComponentName: 'ToggleInput',
    label: 'Transaction Fee',
    placeholder: '',
    description:
      'When enabled, a fee is collected from the sender upon any transfer of the token, paid to the owner of the contract.',
    validationSchema: 'BOOLEAN',
    classes: ['s12', 'l12'],
    defaultValue: false,
    required: false,
  },
  transactionFeeAmount: {
    ComponentName: 'TextInput',
    label: 'Fee Amount',
    placeholder: '0',
    description: 'What percentage fee is charged upon each token transfer.',
    validationSchema: 'DECIMAL_18_PRECISION',
    classes: ['s12', 'l12'],
    dependency: 'transactionFee',
    required: false,
    fieldSuffix: '%',
    requiredWithDependency: true,
  },
  priceFloor: {
    ComponentName: 'ToggleInput',
    label: 'Price Floor',
    placeholder: '',
    description: 'When enabled, anyone can sell the token back to the contract for a fixed price.',
    validationSchema: 'BOOLEAN',
    classes: ['s12', 'l12'],
    defaultValue: false,
    required: false,
  },
  floorPrice: {
    ComponentName: 'TextInput',
    label: 'Price Per Token',
    placeholder: '0.001',
    description:
      'Amount of Ether received for each token sold to the contract. This can be changed later.',
    validationSchema: 'DECIMAL_18_PRECISION',
    classes: ['s12', 'l12'],
    dependency: 'priceFloor',
    required: false,
    fieldSuffix: 'ETH',
    requiredWithDependency: true,
  },
};

export default erc20FieldDefinitions;



// WEBPACK FOOTER //
// ./src/erc20FieldDefinitions.js